<app-side-dialog [disableClose]="true" (closeDialog)="onCloseClick()">
  <div dialogHeader>
    <h2>
      @if (isEditMode) {
        {{ 'pages.settings.userManagement.addTeamDialog.titleEdit' | translate }}
      } @else {
        {{ 'pages.settings.userManagement.addTeamDialog.titleCreate' | translate }}
      }
    </h2>
  </div>

  <div dialogContent class="flex flex-col">
    <form [formGroup]="form" class="flex flex-col gap-4 custom-form" (ngSubmit)="onSaveClick()">
      <mat-form-field class="w-full">
        <input
          matInput
          cdkFocusInitial
          formControlName="name"
          [placeholder]="'pages.settings.userManagement.addTeamDialog.namePlaceholder' | translate"
        />
        <mat-error [control]="form.get('name')" />
      </mat-form-field>

      <app-file-uploader
        #fileUploader
        class="w-full"
        size="big"
        [imageWidth]="80"
        [imageHeight]="80"
        [imageId]="iconId()"
        [fileForm]="form.controls.imageFile"
        [requiredPermission]="[EPermissions.teamCreate]"
        (imageSelected)="onImageSelected($event)"
        (imageRemoved)="onImageRemoved()"
      />

      <div class="flex justify-end gap-3 mt-6">
        <button mat-button type="button" [disabled]="submitLoading()" (click)="onCloseClick()">
          {{ 'shared.cancel' | translate }}
        </button>

        <button mat-flat-button color="primary" type="submit" [disabled]="submitLoading() || isIconUploading()">
          <p [class.hidden]="submitLoading()">{{ 'shared.save' | translate }}</p>

          @if (submitLoading()) {
            <app-dots-spinner />
          }
        </button>
      </div>
    </form>
  </div>
</app-side-dialog>
